import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { getDateInFormat } from "@domains/utils/reportDates";
export const LedgerDetailsMapper = (response, accType) => {
    if (response) {
        return response.map((x) => {
            let common_OBJ = {
                rowNumber: x.rowNumber,
                date: x.date ? getDateInFormat(x.date, "DD MMM YYYY") : "",
                voucherType: x.voucherType,
                exchange: x.exchange,
                narration: x.narration,
                chequeNo: x.chequeNo,
                receiptsInRs: String(x.receiptsInRs).replace(/[()]/g, ""),
                paymentsInRs: x.paymentsInRs,
                ledgerKey: x.ledgerKey,
                settlementNo: x.settlementNo,
            };
            switch (accType) {
                case ILoginAccountTypes.EQ:
                    return Object.assign(Object.assign({}, common_OBJ), { cummulativeBalance: String(x.cummulativeBalance), dueDate: x.dueDate });
                case ILoginAccountTypes.CO:
                    return Object.assign(Object.assign({}, common_OBJ), { cummulativeBalance: String(x.closingBalance) });
            }
        });
    }
    return [];
};
